import { FC, useState } from "react";

import Menu from "./Menu";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useAppSelector } from "redux/hooks";

const NavBar: FC = () => {
  const { t } = useTranslation();

  const [merchantName, setMerchantName] = useState("");
  const { merchant, selectedMerchant } = useAppSelector(
    (state) => state.merchant
  );
  const { userOtp } = useAppSelector((state) => state.otp);
  const { user } = useAppSelector((state) => state.login);
  const userName: string = user?.adSoyad!;
  useEffect(() => {
    merchant?.Merchants?.filter(
      (f: any) => f.No === selectedMerchant && setMerchantName(f.Name)
    );
  }, [merchant?.Merchants, selectedMerchant]);

  let list = [
    {
      id: 1,
      menuName: `${t("avatar_profile")}`,
      menuLink: { link: `my-profile/${merchantName || userName}` },
    },
  ];
  if (userOtp?.UserLevel === "1" || userOtp?.UserLevel === "3") {
    const adminMenu = [
      {
        id: 2,
        menuName: `${t("agent_management")}`,
        menuLink: { link: "/employee-panel" },
      },
      {
        id: 3,
        menuName: `${t("change_merchant")}`,
        menuLink: {
          link: "/choice-merchant",
          state: { is_merchant_change: true },
        },
      },
    ];
    list.push(...adminMenu);
  } else if (userOtp?.UserLevel === "2") {
    const agentMenu = [
      {
        id: 5,
        menuName: `${t("password_refresh")}`,
        menuLink: { link: "/get-password", state: { fromEmpDetail: true } },
      },
    ];
    list.push(...agentMenu);
  }
  list.push({
    id: 4,
    menuName: `${t("avatar_questions")}`,
    menuLink: { link: "/faq-list" },
  });

  return (
    <>
      <Menu menuList={list} />
    </>
  );
};

export default NavBar;
